var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"width":"300","height":"600","color":"transparent"}},[_c('a',{attrs:{"href":_vm.bannerAd.url,"target":"_blank"},on:{"click":function($event){_vm.onClick();
      _vm.$gtag.navigation('click_sponsor_link', _vm.bannerAd.url);}}},[_c('v-img',{attrs:{"src":_vm.bannerAd.file}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }